import {baseBackendRoute} from "../config/generals";

const fmt = (d: Date): string =>
    `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export interface IBuildStatsUrlParams {
    supplyPartnerId: string;
    clientKey: string;
    clientSecret: string;
}

export const buildStatsUrl = (params: IBuildStatsUrlParams): string => {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    const qs = new URLSearchParams({
        clientKey: params.clientKey,
        clientSecret: params.clientSecret,
        supplyPartnerId: params.supplyPartnerId,
        startDate: fmt(yesterday),
        endDate: fmt(today),
        breakdown: "day",
    });

    return `${baseBackendRoute}/api/stats?${qs.toString()}`;
};
